import { PlantDeviceEnumType } from "ngx-core-services";

export const convertProductTypeNameToPlantDeviceType = (productType: string): PlantDeviceEnumType => {
  switch (productType) {
    case 'inverter':
      return PlantDeviceEnumType.INVERTER;
    case 'meter':
      return PlantDeviceEnumType.METER;
    case 'no-zcs':
      return PlantDeviceEnumType.SENSOR;
    case 'evcharge':
      return PlantDeviceEnumType.EVCH;
    case 'enerclic':
      return PlantDeviceEnumType.COMBOX;
    default:
      return PlantDeviceEnumType.INVERTER;
  }

};
